/*!
 *  Content type select form field.
 *  Author: Bjorn Tollstrom <bjorn@rodolfo.se>
 */

import React from "react";
import PropTypes from "prop-types";
import ChoiceField from "Components/UI/Field/ChoiceField";
import FilterField from "Components/UI/Field/FilterField";

class ContentTypeField extends React.Component
{
    constructor(props)
    {
        super(props);

        this.Types = {
            v1: {
                "content::article": "Article",
                //"capturedvideo": "Captured Video",
                "community": "Community",
                "externalLink": "External Link",
                "event": "Event",
                //"learningplan": "Learning Plan",
                "question": "Question",
                "scormcourse": "Scorm Course",
                //"topic": "Topic",
                "uploadedfile": "Uploaded File",
                "user": "User",
                "video": "Video"
            },
            v2: {
                "Topic": "Topics",
                "UploadedFile": "Files",
                "Content::Article": "Articles",
                "ExternalLink": "Links",
                "ScormCourse": "Courses",
                "LearningPlan": "Learning Plans",
                "Question": "Questions",
                "Person": "People",
                "Event": "Events",
                "Video": "Videos",
                "Community": "Communities"
            }
        };
        this.state = {filters: {}};
    }

    componentDidMount()
    {
        const {value, version} = this.props;
        this.setState({filter: {contentType: this.Types[version][value] || -1}});
    }

    /**
     * Adjust field items or load new events when the filters change.
     * @param object e - The event object.
     * @param object filters - New filters.
     * @return void
     */

    SetFilter = (e, filters) =>
    {
        const {id, onChange} = this.props;
        const {filters: currentFilters} = this.state;
        this.setState({filters}, () =>
        {
            for (let key in filters)
            {
                if (filters[key] === currentFilters[key])
                {
                    continue;
                }
                onChange(e, filters[key], key, id);
            }
        });
    }

    /**
     * Set the contrent type filter label.
     * @return string - The label
     */

    SetFilterLabel = () =>
    {
        const {placeholder, version} = this.props;
        const {filters} = this.state;
        return this.Types[version][filters.contentType] || placeholder;
    }

    render()
    {
        const {additionalFields, className, placeholder, version, ...inheritProps} = this.props;
        const {filters} = this.state;
        const CA = ["ContentTypeField"];
        if (className)
        {
            CA.push(className);
        }
        return <FilterField
            {...inheritProps}
            className={CA.join(" ")}
            fields={{
                contentType:
                {
                    options: this.Types[version],
                    placeholder,
                    type: "choice"
                },
                ...additionalFields
            }}
            onChange={this.SetFilter}
            selectedLabel={this.SetFilterLabel}
            values={filters}
        />
        /*return <ChoiceField
            {...inheritProps}
            className={CA.join(" ")}
            options={this.Types[version]}
        />;*/
    }
}

ContentTypeField.propTypes =
{
    addEventListener: PropTypes.object,
    className: PropTypes.string,
    version: PropTypes.string
};

ContentTypeField.defaultProps =
{
    additionalFields: {},
    className: "",
    version: "v1"
};

export default ContentTypeField;